/* eslint-disable */
export default {
  callerCall: 'Anrufer',
  transferCall: 'Weiterleiten',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
